export const BREEZE_SPECIAL = 'breeze-special';